<template>
    <div class="d-flex flex-nowrap gap-3">
        <DisplayTimespan
            :value="value"
            :format="format"
        />
        <GridButton
            :row="row"
            icon="fa-clock"
            text="stationalias.settime"
            @click="setTimeshift"
        />
    </div>
</template>
<script setup lang="ts">
import { DisplayTimespan, GridButton } from '@/components';
import { useDialog } from '@/composeables';
import { TimeSpan } from '@/objects/TimeSpan';
import { StationAlias } from '@/objects/generated';
import type { TimeType } from '@/utilities/dateutils';
import StationAliasTimeshiftView from './StationAliasTimeshiftView.vue';
import { ref } from 'vue';
import type { IGridCompExposed } from '@/components/Grid/Classes';
const props = withDefaults(
    defineProps<{
        value: TimeSpan | null;

        /**
         * The format to use for the time
         * @default TIMEMS3
         */
        format?: TimeType;

        /**
         * The row that triggered the dialog
         */
        row: StationAlias;

        grid?: IGridCompExposed<StationAlias>;
    }>(),
    {
        value: null,
        format: 'TIMEMS3',
    },
);

const rowvalue = ref<StationAlias>(props.row);

// We need a copy that we can change
const internalValue = ref<StationAlias>(
    StationAlias.FromJsValues({
        Timeshift: rowvalue.value.Timeshift,
    }),
);

const setTimeshift = () => {
    useDialog().SaveCancel({
        title: 'stationalias.settimeshift',
        body: StationAliasTimeshiftView,
        vmodel: internalValue,
        saveCallback: async () => {
            // We update the real value with the internal value
            rowvalue.value.Timeshift = internalValue.value.Timeshift;

            props.grid?.purgeCachedData();

            return true;
        },
        options: {
            Size: 'lg',
        },
    });
};
</script>
